// Replace with the real checkout / payment-processor link when one is available.
export const CHECKOUT_URL = '#oferta-pilates';
